<div class="logo-wrapper">
  <a href="javascript:void(0)" [routerLink]="['/']">
    <img
      class="for-light"
      style="width: 100%; max-width: 180px"
      [src]="
        logoLight ||
        'https://capitaldivisas.sfo3.digitaloceanspaces.com/44579e0e-dd0e-4132-adf1-fa048d876068.png'
      "
      alt="logo"
    />
    <img
      class="for-dark"
      style="width: 100%; max-width: 180px"
      [src]="
        logoDark ||
        'https://capitaldivisas.sfo3.digitaloceanspaces.com/44579e0e-dd0e-4132-adf1-fa048d876068.png'
      "
      alt="logo"
    />
  </a>

  @if (type == "sidebar") {
    <ng-content select="[icon]"></ng-content>

    <div class="toggle-sidebar" (click)="toggleSidebar()">
      <app-feather-icon
        [icon]="icon"
        [class]="'status_toggle middle sidebar-toggle'"
      ></app-feather-icon>
    </div>
  }
</div>

@if (type == "header") {
  <ng-content></ng-content>

  <div class="toggle-sidebar" (click)="toggleSidebar()">
    <app-feather-icon
      [icon]="icon"
      [class]="'status_toggle middle sidebar-toggle'"
    ></app-feather-icon>
  </div>
}
